<template>
  <div>
    <keep-alive>
      <component :is="orderComponent"
                 ref="method"
                 :param="param"
                 @order-view="orderView">
      </component>
    </keep-alive>
  </div>
</template>

<script>
import OrderDetail from './OrderDetail'
import OrderList from './OrderList'
import OrderAppleEdit from './OrderAppleEdit'
import OrderSettlement from './OrderSettlement'
import ComplaintOrder from './ComplaintOrder'

export default {
  name: 'OrderIndex',
  components: {
    'order-list': OrderList,
    'order-detail': OrderDetail,
    'order-apple-edit': OrderAppleEdit,
    'order-complaint': ComplaintOrder,
    'order-settlement': OrderSettlement
  },
  data () {
    return {
      showOrderDetail: false,
      orderComponent: 'order-list',
      param: ''
    }
  },
  methods: {
    orderView (view, flag) {
      this.orderComponent = view
      if (flag) {
        this.$nextTick(() => {
          this.param = flag
          this.$refs['method'].changeEvent(flag)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
